import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import Swal from 'sweetalert2';

import { FormBuilder, FormGroup } from '@angular/forms';
import { ReportService } from 'src/app/services/report.service';
import { DebitOrderNotificationService } from 'src/app/services/debit-order-notification.service';
import { BatchProcessModuleType } from 'src/app/enum/batch-processType';
import { NotificationService } from 'src/app/services/notification-service';

@Component({
  selector: 'app-manage-suspension-popup',
  templateUrl: './manage-suspension-popup.component.html',
  styleUrls: ['./manage-suspension-popup.component.scss']
})
export class ManageSuspensionPopupComponent implements OnInit {
  form: FormGroup;
  head: any;
  displayType: any;
  data: any;
  fileName: any;
  file: any;
  isFileSelected = false;
  FileExtention: any;
  documents: any[] = [];
  BatchProcessModuleType = BatchProcessModuleType

  base64: any
  constructor(
    public dialogRef: MatDialogRef<ManageSuspensionPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public value: any,
    private formBuilder: FormBuilder,
    private reportservice: ReportService,
    private DebitOrderNotificationService: DebitOrderNotificationService,
    private toastr: NotificationService,

  ) { }

  ngOnInit(): void {
    this.displayType = this.value.title
    this.head = this.value.head;
    this.data = this.value.data;
    this.form = this.formBuilder.group({
      AttachmentFileName: [],
    })
  }

  downloadtemplate() {
   if (this.displayType == 'mail' || this.displayType == 'suspension' || this.displayType == 'payment' || this.displayType == 'Revoke') {
      this.reportservice.downloadRemainderMailTemplate().subscribe((result) => {
        if (result) {
          const linkSource = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64, ' + result;
          const downloadLink = document.createElement('a');
          let fileName = 'Bulk Invoke template.xlsx';

          if (this.displayType == 'mail')
            fileName = 'Remainder Mail template.xlsx';

          else if (this.displayType == 'suspension')
            fileName = 'Bulk Suspension template.xlsx';

          else if (this.displayType == 'payment')
            fileName = 'Payment Arrangement template.xlsx';
          downloadLink.href = linkSource;
          downloadLink.download = fileName;
          downloadLink.click();
        }
      })
    }
  }
  Close() {
    this.dialogRef.close()

  }

  selectFile() {
    const inputElement = document.createElement('input');
    inputElement.type = 'file';
    inputElement.style.display = 'none';
    document.body.appendChild(inputElement);
    inputElement.click();

    inputElement.addEventListener('change', async (event: any) => {
      const files: FileList = (event.target as HTMLInputElement).files;

      if (!files || files.length === 0) {
        Swal.fire('Warning', 'Please upload a file', 'warning');
        return;
      }
      if (files.length > 1) {
        Swal.fire('Warning', 'Please upload only one file at a time', 'warning');
        return;
      }

      this.file = files[0];
      this.fileName = this.file.name;
      const fileExtension = this.fileName.split('.').pop().toLowerCase();
      const validExtensions = ['csv', 'xlsx', 'xls'];
      const validMimeTypes = ['text/csv', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel'];

      const isValidExtension = validExtensions.includes(fileExtension);
      const isValidMimeType = validMimeTypes.includes(this.file.type);

      if (!isValidExtension || !isValidMimeType) {
        Swal.fire(
          'Warning',
          `Please upload a correct file format (csv, xlsx, xls)`,
          'warning'
        );
        this.fileName = '';
        this.isFileSelected = false;
        document.body.removeChild(inputElement);
        return;
      }
      this.FileExtention = fileExtension;
      this.isFileSelected = true;
      this.form.controls['AttachmentFileName'].setValue(this.fileName);
      console.log(this.file);
      document.body.removeChild(inputElement);
    });
  }

  reset() {
    const txt = 'Are you sure you want to delete?';
    const Yes = 'Yes';
    const No = 'No';
    Swal.fire({
      text: txt,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#7D32DE',
      cancelButtonColor: '#23C00A',
      confirmButtonText: Yes,
      cancelButtonText: No,
    }).then((result) => {
      if (result.value) {
        this.fileName = '';
        this.isFileSelected = false;
        this.form.controls['AttachmentFileName'].setValue(this.fileName);
      }
    });
  }



  save() {
    debugger
    let formData: FormData = new FormData();


    formData.append('file', this.file);
    if (this.displayType == 'mail') {
      formData.append('ManageSuspensionIdKey', this.data);
      formData.append('BatchProcessModuleType', this.BatchProcessModuleType.RemainderMail.toString());
      this.DebitOrderNotificationService.BulkSendRemainderMailToCustomer(formData).subscribe((result) => {
        console.log(result);
        Swal.fire('information!,', 'Bulk Send of Suspension Remainder Mail will be updated shortly and will notify you once the process completed', "info");


      });
    }
    else if (this.displayType == 'suspension') {
      formData.append('ManageSuspensionIdKey', this.data);
      formData.append('BatchProcessModuleType', this.BatchProcessModuleType.suspendCustomers.toString());
      this.DebitOrderNotificationService.BulkSuspendCustomers(formData).subscribe((result) => {
        console.log(result);
        Swal.fire('information!,', 'Bulk Customer Suspension will be updated shortly and will notify you once the process completed', "info");


      });
    }
    else if (this.displayType == 'payment') {
      formData.append('BatchProcessModuleType', this.BatchProcessModuleType.paymentArrangement.toString());
      formData.append('paymentArrangementIdKey', this.data);
      this.DebitOrderNotificationService.bulkpaymentarrangement(formData).subscribe((result) => {
        console.log(result);
        Swal.fire('information!,', 'Bulk payment Arrangement will be updated shortly and will notify you once the process completed', "info");
      });
    }
    else {
      formData.append('BatchProcessModuleType', this.BatchProcessModuleType.BulkRevoke.toString());
      formData.append('ManageSuspensionIdKey', this.data);
      this.DebitOrderNotificationService.ProcessBulkRevoke(formData).subscribe((result) => {
        console.log(result);
        Swal.fire('information!,', 'Bulk Customer Invoke will be updated shortly and will notify you once the process completed', "info");
      });
    }
    this.dialogRef.close(true)



  }

}
